<div class="autocomplete" [class.autocomplete--disabled]="disabled()">
  <fr8bot-ui-dropdown [origin]="fieldOrigin" (opened)="onOpened()">
    <div class="autocomplete__interaction-area" interaction-area>
      @if (label()) {
        <label [for]="id" class="autocomplete__label">
          {{ label() }}
          @if (required()) {
            <span class="autocomplete__label-required">*</span>
          }
        </label>
      }

      <div cdkOverlayOrigin #fieldOrigin="cdkOverlayOrigin">
        <!-- Chrome ignores autocomplete="off" and offers saved emails over the list; it doesn't for one-time-code -->
        <fr8bot-ui-input-field
          [value]="searchText()"
          [isErrorVisible]="false"
          [id]="id"
          [isFocused]="!!dropdown()?.isOpened()"
          [isReadonly]="!!selectedItem()"
          [isInvalid]="isErrorShown()"
          [disabled]="disabled()"
          [placeholder]="placeholder() ?? ''"
          [size]="size()"
          [type]="type()"
          autocomplete="one-time-code"
          (valueChange)="onSearch($event)"
          (touch)="touch.emit()"
        >
          @if (valueTemplate() && selectedItem(); as item) {
            <!-- Inline-size containment: the selected value never sizes the field, so a long
                 one ends in an ellipsis instead of widening the field and its container. -->
            <div
              custom-value-template
              class="tw:min-w-0 tw:flex-1 tw:pr-2 tw:[contain:inline-size]"
            >
              <ng-container
                *ngTemplateOutlet="valueTemplate()!.templateRef; context: { $implicit: item }"
              />
            </div>
          }
          <span postfix class="tw:flex tw:h-full">
            @if (postfixIconRef(); as postfixIcon) {
              <span
                [class.hidden]="hasValue()"
                class="autocomplete__postfix-icon tw:flex tw:w-[var(--field-action-size,48px)] tw:h-full tw:shrink-0 tw:items-center tw:justify-center"
              >
                <ng-container *ngTemplateOutlet="postfixIcon.templateRef" />
              </span>
            } @else {
              <button
                type="button"
                class="tw:flex tw:w-[var(--field-action-size,48px)] tw:h-full tw:shrink-0 tw:items-center tw:justify-center tw:border-0 tw:transition-colors tw:duration-200 tw:cursor-pointer tw:enabled:hover:bg-gray-5 tw:bg-transparent tw:text-inherit tw:disabled:cursor-not-allowed"
                [class.hidden]="hasValue()"
                [disabled]="disabled()"
              >
                <fr8bot-ui-icon
                  [name]="'arrow-down-12'"
                  [size]="12"
                  class="autocomplete__arrow-icon"
                  [class.autocomplete__arrow-icon-flipped]="!!dropdown()?.isOpened()"
                />
              </button>
            }
            <button
              type="button"
              class="autocomplete__remove-icon tw:flex tw:w-[var(--field-action-size,48px)] tw:h-full tw:shrink-0 tw:items-center tw:justify-center tw:border-0 tw:cursor-pointer tw:enabled:hover:bg-gray-5 tw:bg-transparent tw:text-inherit tw:disabled:cursor-not-allowed"
              [class.hidden]="!hasValue()"
              [disabled]="disabled()"
              (click)="clearValue()"
            >
              <fr8bot-ui-icon name="x" [size]="12" />
            </button>
          </span>
        </fr8bot-ui-input-field>
      </div>

      @if (isErrorVisible()) {
        <fr8bot-ui-validation-error [error]="error()" />
      }
    </div>

    <fr8bot-ui-autocomplete-content
      content-area
      [loadingMore]="loadingMore()"
      (scrolledToEnd)="autocompleteScrollEnd.emit()"
    >
      <ng-container empty-result-message>
        <ng-content select="[autocomplete-empty-result-message]" />
      </ng-container>
      <ng-container content>
        <ng-content select="[autocomplete-content]" />
      </ng-container>
    </fr8bot-ui-autocomplete-content>
  </fr8bot-ui-dropdown>
</div>
